import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  ViewEncapsulation
} from '@angular/core';
import {
  Observable,
  Subscription
} from 'rxjs';
import {
  filter,
  startWith,
  switchMap,
  tap
} from 'rxjs/operators';
import {
  Address
} from '@spartacus/core';
import {
  ItemService,
  UserDetailsComponent,
} from '@spartacus/organization/administration/components';
import { UigAccessSubjectService } from '../../services/uig-access-subject/uig-access-subject.service';
import { UigUserItemService } from '../../services/uig-user-item/uig-user-item.service';
import {
  AccessSubject,
  AccessSubjectList,
  AllowedPermission,
  NormalizedAccessSubject
} from '../../store/uig-access-subject/uig-access-subject.model';
import { UigB2BUser } from '../uig-user.model';
import {B2BUserService} from '@spartacus/organization/administration/core';
import {DeliveryMode} from '@spartacus/cart/base/root';

@Component({
    selector: 'app-uig-user-details',
    templateUrl: './uig-user-details.component.html',
    styleUrls: ['./uig-user-details.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: ItemService,
            useExisting: UigUserItemService,
        },
    ],
    host: { class: 'content-wrapper' },
    standalone: false
})
export class UigUserDetailsComponent extends UserDetailsComponent implements OnInit {
  userGuardSubscription: Subscription;
  model$: Observable<UigB2BUser> = this.itemService.key$.pipe(
    switchMap((code) => this.itemService.load(code)),
    tap((userDetails) => {
      this.userRoles = userDetails.roles;
      if(userDetails.roles)
      {
        this.buildAccessSubjectArr(userDetails.roles);
      }
    }),
    startWith({})
  );
  isInEditMode$ = this.itemService.isInEditMode$;

  public userDetailsRoles: string[];

  public deliveryModes: DeliveryMode[];
  public deliveryAddresses: Address[];

  public accessSubjectArr: NormalizedAccessSubject[];
  public accessSubjectOverviewData: AccessSubjectList;

  public userRoles: string[];

  constructor(
    itemService: ItemService<UigB2BUser>,
    private accessSubjectService: UigAccessSubjectService,

    b2bUserService: B2BUserService
  ) {
    super(itemService, b2bUserService);
  }

  ngOnInit(): void {

    this.accessSubjectService.loadAccessSubjectOverview().pipe(
      filter((accessSubjectOverviewData: AccessSubjectList) => accessSubjectOverviewData != null),
      tap((accessSubjectOverviewData: AccessSubjectList) => {
        this.accessSubjectOverviewData = accessSubjectOverviewData;
      })
    )
    .subscribe();
  }

  private buildAccessSubjectArr(userDetailsRoles: string[]): void {
    let normalizedAccessSubjectsArr = [];

    userDetailsRoles.forEach((role: string) => {
      if (this.accessSubjectOverviewData?.ringfotoAccessSubjects) {
        const accessSubjects = this.accessSubjectOverviewData.ringfotoAccessSubjects;

        accessSubjects.forEach((accessSubject: AccessSubject) => {
          accessSubject.allowedPermissions.forEach((allowedPermission: AllowedPermission) => {
            if (allowedPermission) {
              if (role === allowedPermission.uid) {
                let normalizedAccessSubject: NormalizedAccessSubject = {
                  code: accessSubject.code,
                  name: accessSubject.name,
                  order: accessSubject.order,
                  multiplePermissions: accessSubject.multiplePermissions,
                  allowedPermissionCode: allowedPermission.uid,
                  allowedPermissionLabel: allowedPermission.label
                };

                let allowedPermissionIndex = normalizedAccessSubjectsArr.findIndex(x => x.allowedPermissionCode === allowedPermission.uid)

                if (allowedPermissionIndex === -1) {
                  normalizedAccessSubjectsArr.push(normalizedAccessSubject)
                }
              }
            }
          });
        });
      }
    });

    this.accessSubjectArr = normalizedAccessSubjectsArr.sort((a, b) => a.order - b.order);
  }

  public addCheckboxPlaceholder(allowedPermission: AllowedPermission): boolean {
    if (allowedPermission.label === 'bearbeiten') {
      return true;
    } else {
      return false;
    }
  }

  public getAllowedPermission(code: string): string {
    let matchingCodes: NormalizedAccessSubject[];

    if (this.accessSubjectArr) {
      matchingCodes = this.accessSubjectArr.filter((accessSubject: NormalizedAccessSubject) => {
        return accessSubject.code === code
      });
    }

    if (matchingCodes?.[0]) {
      return matchingCodes[0].allowedPermissionLabel;
    } else {
      return '';
    }
  }
}
